<script lang="ts" setup>
interface Props {
  illustration: string;
  filled?: boolean;
}

withDefaults(defineProps<Props>(), {
  filled: false,
});
</script>

<template>
  <KUIUtilInlineSVG :name="`illustrations-${illustration}`" :filled="filled" />
</template>
